import { ReactNode } from 'react';

import { Flex, type FlexProps, Text } from '@spotify-internal/encore-web';

export type FormFieldsBoxProps = {
  children?: ReactNode;
  gap?: FlexProps['gap'];
  direction?: 'row' | 'column';
  className?: string;
};

const FormFieldsBoxRoot = ({
  children,
  gap = 'base',
  direction = 'column',
  className,
}: FormFieldsBoxProps) => (
  <Flex direction={direction} gap={gap} className={className}>
    {children}
  </Flex>
);

export type FormFieldsOptionsProps = {
  children?: ReactNode;
  label?: string;
  className?: string;
};

const Options = ({
  children,
  label = 'Options',
  className,
}: FormFieldsOptionsProps) => (
  <Flex direction="column" gap="tighter-2" className={className}>
    <Text as="span" variant="bodySmallBold">
      {label}
    </Text>
    <Flex wrap="wrap" gap="tighter-2" alignItems="start">
      {children}
    </Flex>
  </Flex>
);

export const FormFieldsBox = Object.assign(FormFieldsBoxRoot, { Options });
